import {
  AsyncCallArgs,
  BoxSpg,
  CardSpg,
  CircularTextLoader,
  RecognitionKind,
  useAsyncCall,
} from "@duosoftbg/nacid-components";
import { getApplicationKind } from "../../../services/seEducationSpecificCalls";
import { useSearchParams } from "react-router-dom";
import React, { useEffect, useState } from "react";

import { CardContent } from "@mui/material";
import ServiceConfigWrapperPage from "../ServiceConfigWrapperPage";
import {
  seOfficialNoteServiceMAConfig,
  seRecognitionServiceMAConfig,
  seVerificationLetterServiceMAConfig,
} from "../../../config/servicesConfigMyApplications";
import SERecognitionEditPage from "./SERecognitionEditPage";
import SEVerLetterEditPage from "./SEVerLetterEditPage";
import SEOfficialNoteEditPage from "./SEOfficialNoteEditPage";

const SeApplicationCommonEditPage = () => {
  const { asyncCall } = useAsyncCall();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [applicationKind, setApplicationKind] = useState(null);

  useEffect(() => {
    const asyncApplicantSubmit: AsyncCallArgs = {
      withGlobalBackdrop: true,
      promise: getApplicationKind(id),
      onSuccess: (response) => {
        setApplicationKind(response?.data);
      },
    };
    asyncCall(asyncApplicantSubmit);
  }, [id]);

  if (!applicationKind) {
    return (
      <>
        <CardSpg my={4} style={{ overflow: "visible" }}>
          <CardContent style={{ position: "relative" }}>
            <BoxSpg>
              <CircularTextLoader />
            </BoxSpg>
          </CardContent>
        </CardSpg>
      </>
    );
  }

  if (applicationKind === RecognitionKind.CERTIFICATE) {
    return (
      <>
        <ServiceConfigWrapperPage
          serviceConfig={seRecognitionServiceMAConfig}
          wrappedPage={<SERecognitionEditPage />}
        />
      </>
    );
  }
  if (applicationKind === RecognitionKind.VERIFICATION_LETTER) {
    return (
      <>
        <ServiceConfigWrapperPage
          serviceConfig={seVerificationLetterServiceMAConfig}
          wrappedPage={<SEVerLetterEditPage />}
        />
      </>
    );
  }
  if (applicationKind === RecognitionKind.OFFICIAL_NOTE) {
    return (
      <>
        <ServiceConfigWrapperPage
          serviceConfig={seOfficialNoteServiceMAConfig}
          wrappedPage={<SEOfficialNoteEditPage />}
        />
      </>
    );
  }
};

export default SeApplicationCommonEditPage;
